import React from 'react';
import { ContentRenderer } from '@jetshop/ui/ContentRenderer';
import { useQuery } from 'react-apollo';
import ContentPageContentQuery from '../../../../components/ContentPage/ContentPageContentQuery.gql';
import { dynamicPageRendererStyle } from './DynamicPageRenderer.style';
import { contentEditorComponents } from '../../ce/ContentEditorComponents';
import { cx } from 'linaria';

/**
 * The DynamicPageContentRenderer function renders the content of a dynamic page.

 * @param {number} pageId For query the content page data
 * @param {object} rendererComponents Pass in custom components to the contentrenderer
 *
 * @return A div width rendered components
 *
 * @docauthor Anders Zetterström @ R3
 */
const DynamicPageContentRenderer = ({ pageId, rendererComponents }) => {
  // TODO - Handle queries when lib is package
  const { data, error } = useQuery(ContentPageContentQuery, {
    variables: {
      id: pageId
    }
  });

  if (!data || error) {
    return null;
  }
  const components = rendererComponents ?? contentEditorComponents;
  const items = data?.page?.data?.items;

  return (
    <div className={cx(dynamicPageRendererStyle, 'dynamic-page-wrapper')}>
      {items && <ContentRenderer items={items} components={components} />}
    </div>
  );
};

export default DynamicPageContentRenderer;
